import momentz from 'moment-timezone';

export const createWarningsListFunc = ({
  appState: {
    targetPrice,
    quoteInfo: { latestPrice },
    confidence,
    weekendErrors,
  },
  optionChainState: { callRows, putRows, warnings },
  highestCallEdge,
  highestCallActual,
  answerArrowPos,
  highestPutEdge,
  highestPutActual,
  noOMS,
}) => {
  const callsPick =
    callRows[
      Math.round(
        highestCallEdge.rowIndex +
          (highestCallActual.rowIndex - highestCallEdge.rowIndex) *
            answerArrowPos
      )
    ];

  const putsPick =
    putRows[
      Math.round(
        highestPutEdge.rowIndex +
          (highestPutActual.rowIndex - highestPutEdge.rowIndex) * answerArrowPos
      )
    ];
  // Check if outside market hours
  const currentHour = momentz.tz(new Date(), 'America/New_York').format('H');
  const currentMinute = momentz.tz(new Date(), 'America/New_York').format('mm');
  const americanHour = momentz.tz(new Date(), 'America/New_York').format('h');
  
  const warningsList = [
    {
      warningText: `It's currently ${americanHour}:${currentMinute}${
        +currentHour > 12 ? 'pm' : 'am'
      } ET. Some information may not be readily available outside of market hours.`,
      index: 0,
      condition: (() => {
        return (
          currentHour < 9 ||
          currentHour > 15 ||
          (currentHour === 9 && currentMinute < 30)
        );
      })(),
      link: null,
    },
    {
      warningText: `This is classed as an ATM option (or close to it). When outright buying an option, the Smartest Investors generally try to stay away from this option.`,
      index: 1,
      condition:
        (targetPrice > latestPrice &&
          callsPick &&
          callsPick.itm_prob >= 0.455 &&
          callsPick.itm_prob <= 0.5549) ||
        (putsPick && putsPick.itm_prob >= 0.455 && putsPick.itm_prob <= 0.5549),
      link: true,
    },
    {
      warningText: `Your Target Stock Price or Confidence is not high enough for the ideal opportunity to use options with this expiration. This option is ITM and highlights two issues. Execution costs are generally higher with ITM options. Second, ITM options have less leverage.`,
      index: 2,
      condition:
        targetPrice > latestPrice &&
        callsPick &&
        callsPick.itm_prob >= 0.555 &&
        callsPick.itm_prob <= 0.7049,
      link: true,
    },
    {
      warningText: `Your Target Stock Price and/or your Confidence is not HIGH enough to warrant the use of options. This option is significantly ITM and should be avoided due to the higher execution costs, very low leverage, and higher risk of upfront premium.`,
      index: 3,
      condition:
        targetPrice > latestPrice && callsPick && callsPick.itm_prob >= 0.705,
      link: true,
    },
    {
      warningText: `Are you sure about your Target Stock Price and Confidence? They may be HIGH. You may consider a lower strike where the Smartest Investors usually buy their options.`,
      index: 4,
      condition:
        targetPrice > latestPrice && callsPick && callsPick.itm_prob <= 0.2049,
      link: true,
    },
    {
      warningText: `You Target Stock Price or Confidence is not LOW enough for the ideal opportunity to use options with this expiration. This option is ITM and highlights two issues. Execution costs are generally higher with ITM options. Second, ITM options have less leverage.`,
      index: 5,
      condition:
        targetPrice < latestPrice &&
        targetPrice > 0 &&
        putsPick &&
        putsPick.itm_prob <= 0.7049 &&
        putsPick.itm_prob >= 0.555,
      link: true,
    },
    {
      warningText: `Your Target Stock Price is not LOW enough to warrant the use of options. This option is be avoided due to the higher execution costs, very low leverage, and risk of upfront premium.`,
      index: 6,
      condition:
        targetPrice < latestPrice &&
        targetPrice > 0 &&
        putsPick &&
        putsPick.itm_prob >= 0.705,
      link: true,
    },
    {
      warningText: `Are you sure about your Target Stock Price and Confidence? This LOW Target Stock Price may be too aggressive, or your Confidence level may be too high. You may consider a higher strike where the Smartest Investors usually buy their options.`,
      index: 7,
      condition:
        targetPrice < latestPrice &&
        targetPrice > 0 &&
        putsPick &&
        putsPick.itm_prob <= 0.2449,
      link: true,
    },
    {
      warningText: `There is no edge in the options that are generally bought by the Smartest Investors. Does a shorter maturity date make sense for you?`,
      index: 8,
      condition: (putsPick || callsPick) && noOMS && targetPrice > 0,
      link: true,
    },
    {
      warningText: `Try picking a Target Stock Price closer to the RR$ in the unshaded windows.`,
      index: 9,
      condition:
        targetPrice > latestPrice &&
        callsPick &&
        highestCallActual.rowIndex === 0,
      link: true,
    },
    {
      warningText: `Try picking a Target Stock Price closer to the RR$ in the unshaded windows`,
      index: 10,
      condition:
        targetPrice < latestPrice &&
        targetPrice > 0 &&
        putsPick &&
        highestPutEdge.rowIndex === 0,
      link: true,
    },
    {
      warningText: `You've set your confidence to 100%... You should never be 100% sure.`,
      index: 11,
      condition: confidence === 10 && targetPrice > 0,
      link: true,
    },
    {
      warningText: weekendErrors,
      index: 1,
      condition: weekendErrors != null,
      link: true,
    },
  ];

  const displayWarnings = warningsList.filter((warning) => warning.condition);
  // warnings = displayWarnings;
  return {
    warnings: displayWarnings,
  };
};



// WEBPACK FOOTER //
// ./src/Shared/addWarnings.js